/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumulative skew`)
};

const es_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesgo acumulado`)
};

const de_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumulativer Skew`)
};

const nl_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumulatieve skew`)
};

const fr_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biais cumulé`)
};

const it_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skew cumulativo`)
};

const pt_br2_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skew acumulado`)
};

const pt_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assimetria cumulativa`)
};

const ja_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累積スキュー`)
};

const zh_gcskew_series_cum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累积偏斜`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_series_cum = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_series_cum(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_series_cum", locale)
	if (locale === "en") return en_gcskew_series_cum(inputs)
	if (locale === "es") return es_gcskew_series_cum(inputs)
	if (locale === "de") return de_gcskew_series_cum(inputs)
	if (locale === "nl") return nl_gcskew_series_cum(inputs)
	if (locale === "fr") return fr_gcskew_series_cum(inputs)
	if (locale === "it") return it_gcskew_series_cum(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_series_cum(inputs)
	if (locale === "pt") return pt_gcskew_series_cum(inputs)
	if (locale === "ja") return ja_gcskew_series_cum(inputs)
	return zh_gcskew_series_cum(inputs)
};